// extracted by mini-css-extract-plugin
module.exports = {"root":"EditSpacesAmenitiesPanel_root__3FwEd","form":"EditSpacesAmenitiesPanel_form__2IKfE","title":"EditSpacesAmenitiesPanel_title__3DTR-"};